import { useTheme } from "@mui/styles";
import Box from "@mui/material/Box";

export default function MuiMarkupTableWrap({ children }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        width: "auto",

        "& h2": {
          color: theme.palette.primary.main,
        },
        "& table": {
          margin: "auto",
          borderRadius: "5px",
          borderCollapse: "separate",
          borderSpacing: 0,
        },

        "& .MuiPaper-root": {
          "& div": {
            margin: "0 !important",
          },
        },

        "& div": {
          "& table,th,td": {
            border: "0.1px solid gray",
          },

          "& table th,table td": {
            padding: "15px",
          },

          "& tbody tr:nth5child(3) td:nth-child(1)": {
            borderBottomLeftRadius: "5px",
          },

          "& tbody tr:nth-child(3) td:nth-child(4)": {
            borderBottomRightRadius: "5px",
          },

          "& tbody td:nth-child(1)": {
            width: "35%",
          },
          "& thead": {
            backgroundColor: theme.palette.primary.main,
            color: "white !important",
          },

          "& table": {
            fontSize: "1em",
            fontWeight: 550,

            "& h2": {
              fontSize: "1em !important",
              fontWeight: "550 !important",
            },
          },

          "& img": {
            maxWidth: "100%",
          },

          "& > iframe": {
            maxWidth: "100%",
          },

          [theme.breakpoints.down("md")]: {
            overflowX: "scroll",
            display: "flex",
            flexDirection: "column",

            "& .MuiPaper-root": {
              "& div": {
                margin: "0 !important",
              },
            },

            "& div": {
              "& table": {
                fontWeight: 550,
                fontSize: "1em",

                "& h2": {
                  fontSize: "1em !important",
                  fontWeight: "550 !important",
                },
              },
            },

            "& tr td:nth-child(1), tr th:nth-child(1)": {
              width: "58%",
            },

            "& tr td:nth-child(4), tr th:nth-child(4)": {
              display: "none",
            },

            "& tr td:nth-child(3), tr th:nth-child(3)": {
              display: "none",
            },
          },
        },
      }}
    >
      {children}
    </Box>
  );
}
